import { render, staticRenderFns } from "./GrupoProdutoList.vue?vue&type=template&id=a8ef71f4"
import script from "./GrupoProdutoList.vue?vue&type=script&lang=js"
export * from "./GrupoProdutoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports